import { lazy } from "react";
const Test = lazy(() => import("@views/TestProgram/"))
const ShowDetail = lazy(() => import("@views/TestProgram/DetailShow"))

const Questions = lazy(() => import("@views/TestProgram/Question/"))
const EQuestions = lazy(() => import("@views/TestProgram/EQuestions/"))
const Topic = lazy(() => import("@views/TestProgram/EQuestions/Topic/"))
const TopicQuestions = lazy (() => import("@views/TestProgram/EQuestions/Topic/Question/"))
const Challenge = lazy(() => import("@views/TestProgram/Test/"))
const AddStudent = lazy(() => import("@views/TestProgram/Test/AddStudent/"))

const Detail = lazy(() => import("@views/TestProgram/DetailShow"))
const ExamSchedule = lazy(() => import("@views/TestProgram/ExamSchedule"))

const ChallengeRoutes = [
    {
        path: '/challenge/challenge/',
        element: <Test />
    },
    {
        path: '/challenge/detail/:detid',
        element: <ShowDetail />
    },
    {
        path: '/challenge/question/',
        element: <Questions />
    },
    {
        path: '/challenge/equestion/',
        element: <EQuestions />
    },
    {
        path: '/challenge/equestion/topic/:lesson_id',
        element: <Topic />
    },
    {
        path: '/challenge/equestion/topic/question/:question_id',
        element: <TopicQuestions />
    },
    {
        path: '/challenge/test/',
        element: <Challenge/>
    },
    {
        path: '/challenge/test/addstudent/:challenge_id/:lesson_id',
        element: <AddStudent/>
    },
    {
        path: 'challenge/detail/:detail_id',
        element: <Detail/>
    },
    {
        path: 'challenge/exam_schedule/',
        element: <ExamSchedule/>
    }
]

export default ChallengeRoutes
